'use strict';

var React = require('react');
var FeesPage = require('./../../components/common/FeesPage.react');

var RootComponent = React.createClass({

    propTypes: {
        renderCurrentPage: React.PropTypes.func.isRequired,
        section: React.PropTypes.string,
        dailyLimit: React.PropTypes.string.isRequired,
        monthlyLimit: React.PropTypes.string.isRequired
    },

    render: function () {
        return this.props.renderCurrentPage({
            section: this.props.section,
            dailyLimit: this.props.dailyLimit,
            monthlyLimit: this.props.monthlyLimit
        });
    }
});

RootComponent.getFlowProps = function () {
    return {
        startPage: FeesPage,
        terminalPages: [FeesPage],
        hideFeedbackLink: [FeesPage]
    };
};

module.exports = RootComponent;



// WEBPACK FOOTER //
// ./public/js/apps/fees/RootComponent.react.js